





























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class gtDropDown extends Vue {
  @Prop({ default: () => [] }) dropList;
  @Prop({ default: "" }) menuWrapClass: String;
  @Prop({ default: "top-start" }) placement: String;
  @Prop({ default: "350" }) width: String;
  @Prop({ default: "help" }) icon: String;
  @Prop() itemIsShow: Function;
  @Prop({ default: () => {} }) node: Object;
  isShow = false;
  clickShow(show) {
    this.isShow = show;
  }
  handleClick(command) {
    this.$emit("handleDropClick", command);
  }
}
